
<template>
  <div class="form-small ">
      <div class="text-center logo-login">
        <img src="../../images/home/nextempleamar-logo.png" width="197" alt="NextempeleaMar" />
      </div>
      <div class="txt-intro mt-2 ">Portal de empleo de<br>ARVI para el sector pesquero</div>
      <form @submit.prevent="handleSubmit" class="card-body mt-2 mb-0">
        <input-float v-model="form.email" :title="__('email')" id="email" />
        <input-float v-model="form.password" type="password" :title="__('password')" id="password" />
        <input type="hidden" name="remember" value="accepted">
        <div class="form-group mb-0">
            <btn block type="submit">{{__('login')}}</btn>
        </div>
      </form>
      <div class="text-center">
        <strong><inertia-link class="form-link" href="/password/reset" preserve-scroll>{{__('forgot_password')}}</inertia-link></strong>
      </div>
      <div class="cookie-consent card-body">

        <div class="text-center mt-3 tit"><strong>Registro de usuarios</strong></div>
        <div class="text-center mt-3 mb-3" v-if="!currentAcceptedPrivacyPolicy">
          Debes aceptar la <a href="/legal/politica-privacidad.html" target="_blank" rel="nofollow">política de privacidad</a> para poder registrarte en la plataforma.
        </div>
        <btn block type="button" v-if="!currentAcceptedPrivacyPolicy" @click="handleAcceptPrivacyPolicy">{{__('Aceptar')}}</btn>
      </div>
      <div class="mt-2 text-center" v-if="currentAcceptedPrivacyPolicy">
          <inertia-link class="form-link" href="/register" preserve-scroll>{{ __('Registro web') }}</inertia-link><br>
          <a class="form-link" href="javascript:void(0);" @click="openModal">
              {{__('Regístrate subiendo tu CV')}}
          </a>
      </div>
    <Dialog v-model:visible="viewCvModal" modal header="Regístrate subiento tu CV" style="width: 740px;">
        <div v-if="!cvSent">
            <form @submit.prevent="SubmitCV" enctype="multipart/form-data">
                <div class="mb-3">Adjunta tu Currículum y regístrate en tan solo un clic.</div>
                <label class="file-upload">
                    <input
                    id="cv"
                    name="cv"
                    type="file"
                    accept="application/pdf"
                    :maxFileSize="1000000"
                    @change="handleDocumento"
                    >
                    <span class="p-button p-component outline button-big-2"><i class="pi pi-upload"/>Adjuntar CV</span>
                </label>
                <div v-if="form.cv" class="mb-3"><span class="txt-file-selected">Documento seleccionado:</span> {{ form.cv.name }}</div>
                <div v-if="cvError" class="error-msg mt-2">
                    <p>No has seleccionado ningún fichero.
                      <br>Para finalizar el registro con Curriculum antes debes seleccionar el fichero.</p>
                </div>
                <div class="form-group mt-4">
                    <btn block type="submit">{{ __('Enviar') }}</btn>
                </div>
            </form>
            </div>
            <div v-else>
            <p>Gracias por enviarnos tu curriculum.</p>
            <p>En breve recibirás un correo electrónico para que puedas acceder a tu área de cliente y confirmar los datos del registro.</p>
            <btn block @click="viewCvModal=false">Cerrar</btn>
        </div>
    </Dialog>
  </div>
</template>

<script>
import Dialog from 'primevue/dialog';
import InputSwitch from "primevue/inputswitch";
import { Inertia } from "@inertiajs/inertia";
import { useCookies } from "vue3-cookies";
import { ref, onMounted, watch } from "vue";

export default
{
    name: "Login",
    components: {
        Dialog,
        InputSwitch
    },
    props: {
        acceptedPrivacyPolicy: Boolean
    },
    setup(props){
        const { cookies } = useCookies();

        const currentAcceptedPrivacyPolicy = ref(props.acceptedPrivacyPolicy);

        onMounted( () => {
            currentAcceptedPrivacyPolicy.value = false;
            if (cookies.isKey("acceptedPrivacyPolicy")) {
                currentAcceptedPrivacyPolicy.value = true;
            }
            else if (props.acceptedPrivacyPolicy) {
                currentAcceptedPrivacyPolicy.value = true;
                cookies.set("acceptedPrivacyPolicy", "true");
            }
        });
        watch(
            () => props.acceptedPrivacyPolicy,
            (newVal) => {
              currentAcceptedPrivacyPolicy.value = newVal;
            }
        );

      return {
        cookies,
        currentAcceptedPrivacyPolicy
      }
    },
    data()
    {
        return {
            form:
            {
                email: "",
                password: "",
                cookies: false,
                remember: false,
                cv:null
            },
            viewCvModal: false,
            //viewConceptNofileModal: false,
            cvSent: false,
            cvError: false
        }
    },
    methods:
    {
        handleDocumento(event) {
            this.form.cv = event.target.files[0];
            this.cvError = false;
        },
        handleAcceptPrivacyPolicy() {
            this.$inertia.post("/ajax/policy/accept", {
                onSuccess: (data) => {
                }
            });
        },
        handleSubmit( event )
        {
            this.$inertia.post( "/login", this.form,
            {
                preserveState: true
            } )
        },
        SubmitCV(event) {
            let inputCv = document.getElementById("cv");
            if(inputCv.files.length >0){
                this.form.cv = inputCv.files[0];
                this.$inertia.post("/cv_upload", this.form,
                {                              
                    onSuccess: () => {
                      this.cvSent = true;
                    }                
                });
            } else {
                this.cvError = true;
            }
        },
        openModal () {
            this.form.cv = null;
            this.cvError = false;
            this.viewCvModal=true;
        },
    },
}
</script>
<style lang="scss" scoped>

</style>